import { LocationRecord } from '@homepage/types/location';

export enum Location {
  Druckwerk = 'druckwerk',
  Suhr = 'suhr',
}

export const TRAINING_LOCATIONS: Record<Location, LocationRecord> = {
  [Location.Druckwerk]: {
    footnote: '¹ Parkplätze im Hinterhof.',
    id: 'druckwerk',
    text: 'Druckwerk Euren, Ottostr. 29, 54294 Trier¹',
    url: 'https://maps.app.goo.gl/XzjyacmmaYpryoNi7',
  },
  [Location.Suhr]: {
    id: 'suhr',
    text: 'Otto-Suhr-Allee 94, 10585 Berlin',
    url: 'https://maps.app.goo.gl/w4RASWP9mPvT6Tc9A',
  },
};
